import { render, staticRenderFns } from "./service.vue?vue&type=template&id=3b20d1d4&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&id=3b20d1d4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20d1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b20d1d4')) {
      api.createRecord('3b20d1d4', component.options)
    } else {
      api.reload('3b20d1d4', component.options)
    }
    module.hot.accept("./service.vue?vue&type=template&id=3b20d1d4&scoped=true&", function () {
      api.rerender('3b20d1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/lingyue-tech/index/component/service/service.vue"
export default component.exports